import React, { useState } from "react";
import ApplicationPopup from "../Popup/ApplicationPopup"; // Добавляем импорт попапа
import "./css/ForWhom.css";

const ForWhom = () => {
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  const audiences = [
    {
      title: "Государственные учреждения",
      description: "Надёжная защита персональных данных граждан в соответствии с требованиями законодательства."
    },
    {
      title: "Крупные компании",
      description: "Идеальное решение для компаний с большим объёмом документов и строгими требованиями к защите данных."
    },
    {
      title: "Банки и финтех",
      description: "Полный контроль за хранением и обработкой персональных данных клиентов в финансовом секторе."
    },
    {
      title: "Медицинские организации",
      description: "Защита медицинской тайны и персональных данных пациентов в соответствии с ФЗ-323."
    },
    {
      title: "IT и облачные провайдеры",
      description: "Автоматический аудит клиентских данных в облачных средах и дата-центрах."
    },
    {
      title: "Ритейл и E-commerce",
      description: "Защита данных покупателей и автоматизация compliance процессов."
    }
  ];

  const handleOpenPopup = () => {
    setIsPopupOpen(true);
  };

  const handleClosePopup = () => {
    setIsPopupOpen(false);
  };

  return (
    <section className="for-whom">
      <div className="container for-whom-container">
        <div className="for-whom-header">
          <h2 className="for-whom-title">Для кого подходит Безопасный Контур?</h2>
          <p className="for-whom-subtitle">
            Наше решение предназначено для организаций, которые работают с персональными данными 
            и стремятся обеспечить их максимальную защиту в соответствии с законодательством.
          </p>
        </div>

        <div className="audience-cards">
          {audiences.map((audience, index) => (
            <div key={index} className="audience-card">
              <div className="card-number">0{index + 1}</div>
              <div className="card-content">
                <h3 className="card-title">{audience.title}</h3>
                <p className="card-description">{audience.description}</p>
              </div>
              <div className="card-divider"></div>
            </div>
          ))}
        </div>

        <div className="for-whom-footer">
          <div className="footer-content">
            <h3>Нужна индивидуальная консультация?</h3>
            <p>Наши эксперты помогут адаптировать решение под ваши задачи</p>
            <button className="consultation-btn" onClick={handleOpenPopup}>
              Обсудить проект
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                <path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </button>
          </div>
        </div>
      </div>

      {/* Добавляем попап */}
      <ApplicationPopup 
        isOpen={isPopupOpen}
        onClose={handleClosePopup}
        type="Индивидуальная консультация"
        title="Обсудить проект"
      />
    </section>
  );
};

export default ForWhom;